import * as React from 'react';

type Props = {
    message: string;
}

const Exception = ({ message }: Props) => {
    return (
        <div className="container content-section">
            <div className="prosa-container">
                <div className="mx-auto shadow p-4 rounded  border-light">
                    <div className="text-center my-6 px-5">
                        <p>{message}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Exception;